function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { toSafe, wrapGenerator } from "./_util/arrayIterator.mjs";
import { convertToNumber, roundToFloat16Bits } from "./_util/converter.mjs";
import { isArrayBuffer, isBigIntTypedArray, isCanonicalIntegerIndexString, isObject, isObjectLike, isOrdinaryArray, isOrdinaryTypedArray, isSharedArrayBuffer, isTypedArray } from "./_util/is.mjs";
import { ATTEMPTING_TO_ACCESS_DETACHED_ARRAYBUFFER, CANNOT_CONVERT_UNDEFINED_OR_NULL_TO_OBJECT, CANNOT_MIX_BIGINT_AND_OTHER_TYPES, DERIVED_CONSTRUCTOR_CREATED_TYPEDARRAY_OBJECT_WHICH_WAS_TOO_SMALL_LENGTH, ITERATOR_PROPERTY_IS_NOT_CALLABLE, OFFSET_IS_OUT_OF_BOUNDS, REDUCE_OF_EMPTY_ARRAY_WITH_NO_INITIAL_VALUE, SPECIES_CONSTRUCTOR_DIDNT_RETURN_TYPEDARRAY_OBJECT, THE_CONSTRUCTOR_PROPERTY_VALUE_IS_NOT_AN_OBJECT, THIS_CONSTRUCTOR_IS_NOT_A_SUBCLASS_OF_FLOAT16ARRAY, THIS_IS_NOT_A_FLOAT16ARRAY_OBJECT } from "./_util/messages.mjs";
import { ArrayBufferIsView, ArrayPrototypeJoin, ArrayPrototypePush, ArrayPrototypeToLocaleString, NativeArrayBuffer, NativeObject, NativeProxy, NativeRangeError, NativeSet, NativeTypeError, NativeUint16Array, NativeWeakMap, NumberIsNaN, ObjectDefineProperty, ObjectFreeze, ObjectHasOwn, ObjectPrototypeIsPrototypeOf, ReflectApply, ReflectConstruct, ReflectDefineProperty, ReflectGet, ReflectGetOwnPropertyDescriptor, ReflectGetPrototypeOf, ReflectHas, ReflectOwnKeys, ReflectSet, ReflectSetPrototypeOf, SetPrototypeAdd, SetPrototypeHas, SymbolFor, SymbolIterator, SymbolToStringTag, TypedArray, TypedArrayPrototype, TypedArrayPrototypeCopyWithin, TypedArrayPrototypeEntries, TypedArrayPrototypeFill, TypedArrayPrototypeGetBuffer, TypedArrayPrototypeGetByteOffset, TypedArrayPrototypeGetLength, TypedArrayPrototypeKeys, TypedArrayPrototypeReverse, TypedArrayPrototypeSet, TypedArrayPrototypeSlice, TypedArrayPrototypeSort, TypedArrayPrototypeSubarray, TypedArrayPrototypeValues, Uint16ArrayFrom, WeakMapPrototypeGet, WeakMapPrototypeHas, WeakMapPrototypeSet } from "./_util/primordials.mjs";
import { IsDetachedBuffer, SpeciesConstructor, ToIntegerOrInfinity, ToLength, defaultCompare } from "./_util/spec.mjs";
var BYTES_PER_ELEMENT = 2;
var brand = SymbolFor("__Float16Array__");
/** @type {WeakMap<Float16Array, Uint16Array & { __float16bits: never }>} */

var float16bitsArrays = new NativeWeakMap();
/**
 * @param {unknown} target
 * @throws {TypeError}
 * @returns {boolean}
 */

function hasFloat16ArrayBrand(target) {
  if (!isObjectLike(target)) {
    return false;
  }

  var prototype = ReflectGetPrototypeOf(target);

  if (!isObjectLike(prototype)) {
    return false;
  }

  var constructor = prototype.constructor;

  if (constructor === undefined) {
    return false;
  }

  if (!isObject(constructor)) {
    throw NativeTypeError(THE_CONSTRUCTOR_PROPERTY_VALUE_IS_NOT_AN_OBJECT);
  }

  return ReflectHas(constructor, brand);
}
/**
 * @param {unknown} target
 * @returns {target is Float16Array}
 */


export function isFloat16Array(target) {
  return WeakMapPrototypeHas(float16bitsArrays, target) || !ArrayBufferIsView(target) && hasFloat16ArrayBrand(target);
}
/**
 * @param {unknown} target
 * @throws {TypeError}
 * @returns {asserts target is Float16Array}
 */

function assertFloat16Array(target) {
  if (!isFloat16Array(target)) {
    throw NativeTypeError(THIS_IS_NOT_A_FLOAT16ARRAY_OBJECT);
  }
}
/**
 * @param {unknown} target
 * @param {number=} count
 * @throws {TypeError}
 * @returns {asserts target is Uint8Array|Uint8ClampedArray|Uint16Array|Uint32Array|Int8Array|Int16Array|Int32Array|Float16Array|Float32Array|Float64Array}
 */


function assertSpeciesTypedArray(target, count) {
  var isTargetFloat16Array = isFloat16Array(target);
  var isTargetTypedArray = isTypedArray(target);

  if (!isTargetFloat16Array && !isTargetTypedArray) {
    throw NativeTypeError(SPECIES_CONSTRUCTOR_DIDNT_RETURN_TYPEDARRAY_OBJECT);
  }

  if (typeof count === "number") {
    var length;

    if (isTargetFloat16Array) {
      var float16bitsArray = getFloat16BitsArray(target);
      length = TypedArrayPrototypeGetLength(float16bitsArray);
    } else {
      length = TypedArrayPrototypeGetLength(target);
    }

    if (length < count) {
      throw NativeTypeError(DERIVED_CONSTRUCTOR_CREATED_TYPEDARRAY_OBJECT_WHICH_WAS_TOO_SMALL_LENGTH);
    }
  }

  if (isBigIntTypedArray(target)) {
    throw NativeTypeError(CANNOT_MIX_BIGINT_AND_OTHER_TYPES);
  }
}
/**
 * @param {Float16Array} float16
 * @throws {TypeError}
 * @returns {Uint16Array & { __float16bits: never }}
 */


function getFloat16BitsArray(float16) {
  var float16bitsArray = WeakMapPrototypeGet(float16bitsArrays, float16);

  if (float16bitsArray !== undefined) {
    var _buffer = TypedArrayPrototypeGetBuffer(float16bitsArray);

    if (IsDetachedBuffer(_buffer)) {
      throw NativeTypeError(ATTEMPTING_TO_ACCESS_DETACHED_ARRAYBUFFER);
    }

    return float16bitsArray;
  } // from another Float16Array instance (a different version?)
  // @ts-ignore


  var buffer = float16.buffer;

  if (IsDetachedBuffer(buffer)) {
    throw NativeTypeError(ATTEMPTING_TO_ACCESS_DETACHED_ARRAYBUFFER);
  }

  var cloned = ReflectConstruct(Float16Array, [buffer, // @ts-ignore
  float16.byteOffset, // @ts-ignore
  float16.length], float16.constructor);
  return WeakMapPrototypeGet(float16bitsArrays, cloned);
}
/**
 * @param {Uint16Array & { __float16bits: never }} float16bitsArray
 * @returns {number[]}
 */


function copyToArray(float16bitsArray) {
  var length = TypedArrayPrototypeGetLength(float16bitsArray);
  var array = [];

  for (var i = 0; i < length; ++i) {
    array[i] = convertToNumber(float16bitsArray[i]);
  }

  return array;
}
/** @type {Set<string | symbol>} */


var TypedArrayPrototypeGetterKeys = new NativeSet();

var _iterator = _createForOfIteratorHelper(ReflectOwnKeys(TypedArrayPrototype)),
    _step;

try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var key = _step.value;

    // @@toStringTag method is defined in Float16Array.prototype
    if (key === SymbolToStringTag) {
      continue;
    }

    var descriptor = ReflectGetOwnPropertyDescriptor(TypedArrayPrototype, key);

    if (ObjectHasOwn(descriptor, "get")) {
      SetPrototypeAdd(TypedArrayPrototypeGetterKeys, key);
    }
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

var handler = ObjectFreeze(
/** @type {ProxyHandler<Float16Array>} */
{
  /** limitation: If the getter property is the same as %TypedArray%.prototype, the receiver is not passed */
  get: function get(target, key, receiver) {
    if (isCanonicalIntegerIndexString(key) && ObjectHasOwn(target, key)) {
      return convertToNumber(ReflectGet(target, key));
    } // %TypedArray%.prototype getter properties cannot called by Proxy receiver


    if (SetPrototypeHas(TypedArrayPrototypeGetterKeys, key) && ObjectPrototypeIsPrototypeOf(TypedArrayPrototype, target)) {
      return ReflectGet(target, key);
    }

    return ReflectGet(target, key, receiver);
  },
  set: function set(target, key, value, receiver) {
    if (isCanonicalIntegerIndexString(key) && ObjectHasOwn(target, key)) {
      return ReflectSet(target, key, roundToFloat16Bits(value));
    }

    return ReflectSet(target, key, value, receiver);
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, key) {
    if (isCanonicalIntegerIndexString(key) && ObjectHasOwn(target, key)) {
      var descriptor = ReflectGetOwnPropertyDescriptor(target, key);
      descriptor.value = convertToNumber(descriptor.value);
      return descriptor;
    }

    return ReflectGetOwnPropertyDescriptor(target, key);
  },
  defineProperty: function defineProperty(target, key, descriptor) {
    if (isCanonicalIntegerIndexString(key) && ObjectHasOwn(target, key) && ObjectHasOwn(descriptor, "value")) {
      descriptor.value = roundToFloat16Bits(descriptor.value);
      return ReflectDefineProperty(target, key, descriptor);
    }

    return ReflectDefineProperty(target, key, descriptor);
  }
});
export var Float16Array = /*#__PURE__*/function () {
  /** @see https://tc39.es/ecma262/#sec-typedarray */
  function Float16Array(input, _byteOffset, _length) {
    _classCallCheck(this, Float16Array);

    /** @type {Uint16Array & { __float16bits: never }} */
    var float16bitsArray;

    if (isFloat16Array(input)) {
      float16bitsArray = ReflectConstruct(NativeUint16Array, [getFloat16BitsArray(input)], this instanceof Float16Array ? this.constructor : void 0);
    } else if (isObject(input) && !isArrayBuffer(input)) {
      // object without ArrayBuffer

      /** @type {ArrayLike<unknown>} */
      var list;
      /** @type {number} */

      var length;

      if (isTypedArray(input)) {
        // TypedArray
        list = input;
        length = TypedArrayPrototypeGetLength(input);
        var buffer = TypedArrayPrototypeGetBuffer(input);
        var BufferConstructor = !isSharedArrayBuffer(buffer) ?
        /** @type {ArrayBufferConstructor} */
        SpeciesConstructor(buffer, NativeArrayBuffer) : NativeArrayBuffer;

        if (IsDetachedBuffer(buffer)) {
          throw NativeTypeError(ATTEMPTING_TO_ACCESS_DETACHED_ARRAYBUFFER);
        }

        if (isBigIntTypedArray(input)) {
          throw NativeTypeError(CANNOT_MIX_BIGINT_AND_OTHER_TYPES);
        }

        var data = new BufferConstructor(length * BYTES_PER_ELEMENT);
        float16bitsArray = ReflectConstruct(NativeUint16Array, [data], this instanceof Float16Array ? this.constructor : void 0);
      } else {
        var iterator = input[SymbolIterator];

        if (iterator != null && typeof iterator !== "function") {
          throw NativeTypeError(ITERATOR_PROPERTY_IS_NOT_CALLABLE);
        }

        if (iterator != null) {
          // Iterable (Array)
          // for optimization
          if (isOrdinaryArray(input)) {
            list = input;
            length = input.length;
          } else {
            // @ts-ignore
            // eslint-disable-next-line no-restricted-syntax
            list = _toConsumableArray(input);
            length = list.length;
          }
        } else {
          // ArrayLike
          list =
          /** @type {ArrayLike<unknown>} */
          input;
          length = ToLength(list.length);
        }

        float16bitsArray = ReflectConstruct(NativeUint16Array, [length], this instanceof Float16Array ? this.constructor : void 0);
      } // set values


      for (var i = 0; i < length; ++i) {
        float16bitsArray[i] = roundToFloat16Bits(list[i]);
      }
    } else {
      // primitive, ArrayBuffer
      float16bitsArray = ReflectConstruct(NativeUint16Array, arguments, this instanceof Float16Array ? this.constructor : void 0);
    }

    var proxy = new NativeProxy(
    /** @type {any} */
    float16bitsArray, handler); // proxy private storage

    WeakMapPrototypeSet(float16bitsArrays, proxy, float16bitsArray);
    return proxy;
  }
  /**
   * limitation: `Object.getOwnPropertyNames(Float16Array)` or `Reflect.ownKeys(Float16Array)` include this key
   *
   * @see https://tc39.es/ecma262/#sec-%typedarray%.from
   */


  _createClass(Float16Array, [{
    key: "keys",
    value:
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys */
    function keys() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      return TypedArrayPrototypeKeys(float16bitsArray);
    }
    /**
     * limitation: returns a object whose prototype is not `%ArrayIteratorPrototype%`
     *
     * @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
     */

  }, {
    key: "values",
    value: function values() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      return wrapGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator2, _step2, val;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // eslint-disable-next-line no-restricted-syntax
                _iterator2 = _createForOfIteratorHelper(TypedArrayPrototypeValues(float16bitsArray));
                _context.prev = 1;

                _iterator2.s();

              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 9;
                  break;
                }

                val = _step2.value;
                _context.next = 7;
                return convertToNumber(val);

              case 7:
                _context.next = 3;
                break;

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                _iterator2.e(_context.t0);

              case 14:
                _context.prev = 14;

                _iterator2.f();

                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 14, 17]]);
      })());
    }
    /**
     * limitation: returns a object whose prototype is not `%ArrayIteratorPrototype%`
     *
     * @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
     */

  }, {
    key: "entries",
    value: function entries() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      return wrapGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator3, _step3, _ref3, _ref2, i, val;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // eslint-disable-next-line no-restricted-syntax
                _iterator3 = _createForOfIteratorHelper(TypedArrayPrototypeEntries(float16bitsArray));
                _context2.prev = 1;

                _iterator3.s();

              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context2.next = 12;
                  break;
                }

                _ref3 = _step3.value;
                _ref2 = _slicedToArray(_ref3, 2);
                i = _ref2[0];
                val = _ref2[1];
                _context2.next = 10;
                return (
                  /** @type {[Number, number]} */
                  [i, convertToNumber(val)]
                );

              case 10:
                _context2.next = 3;
                break;

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](1);

                _iterator3.e(_context2.t0);

              case 17:
                _context2.prev = 17;

                _iterator3.f();

                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 14, 17, 20]]);
      })());
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.at */

  }, {
    key: "at",
    value: function at(index) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var relativeIndex = ToIntegerOrInfinity(index);
      var k = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;

      if (k < 0 || k >= length) {
        return;
      }

      return convertToNumber(float16bitsArray[k]);
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.map */

  }, {
    key: "map",
    value: function map(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];
      var Constructor = SpeciesConstructor(float16bitsArray, Float16Array); // for optimization

      if (Constructor === Float16Array) {
        var proxy = new Float16Array(length);

        var _array = getFloat16BitsArray(proxy);

        for (var i = 0; i < length; ++i) {
          var val = convertToNumber(float16bitsArray[i]);
          _array[i] = roundToFloat16Bits(ReflectApply(callback, thisArg, [val, i, this]));
        }

        return proxy;
      }

      var array = new Constructor(length);
      assertSpeciesTypedArray(array, length);

      for (var _i2 = 0; _i2 < length; ++_i2) {
        var _val = convertToNumber(float16bitsArray[_i2]);

        array[_i2] = ReflectApply(callback, thisArg, [_val, _i2, this]);
      }

      return (
        /** @type {any} */
        array
      );
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter */

  }, {
    key: "filter",
    value: function filter(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];
      var kept = [];

      for (var i = 0; i < length; ++i) {
        var val = convertToNumber(float16bitsArray[i]);

        if (ReflectApply(callback, thisArg, [val, i, this])) {
          ArrayPrototypePush(kept, val);
        }
      }

      var Constructor = SpeciesConstructor(float16bitsArray, Float16Array);
      var array = new Constructor(kept);
      assertSpeciesTypedArray(array);
      return (
        /** @type {any} */
        array
      );
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce */

  }, {
    key: "reduce",
    value: function reduce(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);

      if (length === 0 && (arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        throw NativeTypeError(REDUCE_OF_EMPTY_ARRAY_WITH_NO_INITIAL_VALUE);
      }

      var accumulator, start;

      if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        accumulator = convertToNumber(float16bitsArray[0]);
        start = 1;
      } else {
        accumulator = arguments.length <= 1 ? undefined : arguments[1];
        start = 0;
      }

      for (var i = start; i < length; ++i) {
        accumulator = callback(accumulator, convertToNumber(float16bitsArray[i]), i, this);
      }

      return accumulator;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright */

  }, {
    key: "reduceRight",
    value: function reduceRight(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);

      if (length === 0 && (arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        throw NativeTypeError(REDUCE_OF_EMPTY_ARRAY_WITH_NO_INITIAL_VALUE);
      }

      var accumulator, start;

      if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        accumulator = convertToNumber(float16bitsArray[length - 1]);
        start = length - 2;
      } else {
        accumulator = arguments.length <= 1 ? undefined : arguments[1];
        start = length - 1;
      }

      for (var i = start; i >= 0; --i) {
        accumulator = callback(accumulator, convertToNumber(float16bitsArray[i]), i, this);
      }

      return accumulator;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach */

  }, {
    key: "forEach",
    value: function forEach(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = 0; i < length; ++i) {
        ReflectApply(callback, thisArg, [convertToNumber(float16bitsArray[i]), i, this]);
      }
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.find */

  }, {
    key: "find",
    value: function find(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = 0; i < length; ++i) {
        var value = convertToNumber(float16bitsArray[i]);

        if (ReflectApply(callback, thisArg, [value, i, this])) {
          return value;
        }
      }
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex */

  }, {
    key: "findIndex",
    value: function findIndex(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = 0; i < length; ++i) {
        var value = convertToNumber(float16bitsArray[i]);

        if (ReflectApply(callback, thisArg, [value, i, this])) {
          return i;
        }
      }

      return -1;
    }
    /** @see https://tc39.es/proposal-array-find-from-last/index.html#sec-%typedarray%.prototype.findlast */

  }, {
    key: "findLast",
    value: function findLast(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = length - 1; i >= 0; --i) {
        var value = convertToNumber(float16bitsArray[i]);

        if (ReflectApply(callback, thisArg, [value, i, this])) {
          return value;
        }
      }
    }
    /** @see https://tc39.es/proposal-array-find-from-last/index.html#sec-%typedarray%.prototype.findlastindex */

  }, {
    key: "findLastIndex",
    value: function findLastIndex(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = length - 1; i >= 0; --i) {
        var value = convertToNumber(float16bitsArray[i]);

        if (ReflectApply(callback, thisArg, [value, i, this])) {
          return i;
        }
      }

      return -1;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.every */

  }, {
    key: "every",
    value: function every(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = 0; i < length; ++i) {
        if (!ReflectApply(callback, thisArg, [convertToNumber(float16bitsArray[i]), i, this])) {
          return false;
        }
      }

      return true;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.some */

  }, {
    key: "some",
    value: function some(callback) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var thisArg = arguments.length <= 1 ? undefined : arguments[1];

      for (var i = 0; i < length; ++i) {
        if (ReflectApply(callback, thisArg, [convertToNumber(float16bitsArray[i]), i, this])) {
          return true;
        }
      }

      return false;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.set */

  }, {
    key: "set",
    value: function set(input) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var targetOffset = ToIntegerOrInfinity(arguments.length <= 1 ? undefined : arguments[1]);

      if (targetOffset < 0) {
        throw NativeRangeError(OFFSET_IS_OUT_OF_BOUNDS);
      }

      if (input == null) {
        throw NativeTypeError(CANNOT_CONVERT_UNDEFINED_OR_NULL_TO_OBJECT);
      }

      if (isBigIntTypedArray(input)) {
        throw NativeTypeError(CANNOT_MIX_BIGINT_AND_OTHER_TYPES);
      } // for optimization


      if (isFloat16Array(input)) {
        // peel off Proxy
        return TypedArrayPrototypeSet(getFloat16BitsArray(this), getFloat16BitsArray(input), targetOffset);
      }

      if (isTypedArray(input)) {
        var buffer = TypedArrayPrototypeGetBuffer(input);

        if (IsDetachedBuffer(buffer)) {
          throw NativeTypeError(ATTEMPTING_TO_ACCESS_DETACHED_ARRAYBUFFER);
        }
      }

      var targetLength = TypedArrayPrototypeGetLength(float16bitsArray);
      var src = NativeObject(input);
      var srcLength = ToLength(src.length);

      if (targetOffset === Infinity || srcLength + targetOffset > targetLength) {
        throw NativeRangeError(OFFSET_IS_OUT_OF_BOUNDS);
      }

      for (var i = 0; i < srcLength; ++i) {
        float16bitsArray[i + targetOffset] = roundToFloat16Bits(src[i]);
      }
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse */

  }, {
    key: "reverse",
    value: function reverse() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      TypedArrayPrototypeReverse(float16bitsArray);
      return this;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill */

  }, {
    key: "fill",
    value: function fill(value) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);

      for (var _len = arguments.length, opts = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        opts[_key - 1] = arguments[_key];
      }

      TypedArrayPrototypeFill.apply(void 0, [float16bitsArray, roundToFloat16Bits(value)].concat(_toConsumableArray(toSafe(opts))));
      return this;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin */

  }, {
    key: "copyWithin",
    value: function copyWithin(target, start) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);

      for (var _len2 = arguments.length, opts = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        opts[_key2 - 2] = arguments[_key2];
      }

      TypedArrayPrototypeCopyWithin.apply(void 0, [float16bitsArray, target, start].concat(_toConsumableArray(toSafe(opts))));
      return this;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort */

  }, {
    key: "sort",
    value: function sort() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var compare = (arguments.length <= 0 ? undefined : arguments[0]) !== undefined ? arguments.length <= 0 ? undefined : arguments[0] : defaultCompare;
      TypedArrayPrototypeSort(float16bitsArray, function (x, y) {
        return compare(convertToNumber(x), convertToNumber(y));
      });
      return this;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice */

  }, {
    key: "slice",
    value: function slice() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var Constructor = SpeciesConstructor(float16bitsArray, Float16Array); // for optimization

      for (var _len3 = arguments.length, opts = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        opts[_key3] = arguments[_key3];
      }

      if (Constructor === Float16Array) {
        var uint16 = new NativeUint16Array(TypedArrayPrototypeGetBuffer(float16bitsArray), TypedArrayPrototypeGetByteOffset(float16bitsArray), TypedArrayPrototypeGetLength(float16bitsArray));
        return new Float16Array(TypedArrayPrototypeGetBuffer(TypedArrayPrototypeSlice.apply(void 0, [uint16].concat(_toConsumableArray(toSafe(opts))))));
      }

      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var start = ToIntegerOrInfinity(opts[0]);
      var end = opts[1] === undefined ? length : ToIntegerOrInfinity(opts[1]);
      var k;

      if (start === -Infinity) {
        k = 0;
      } else if (start < 0) {
        k = length + start > 0 ? length + start : 0;
      } else {
        k = length < start ? length : start;
      }

      var final;

      if (end === -Infinity) {
        final = 0;
      } else if (end < 0) {
        final = length + end > 0 ? length + end : 0;
      } else {
        final = length < end ? length : end;
      }

      var count = final - k > 0 ? final - k : 0;
      var array = new Constructor(count);
      assertSpeciesTypedArray(array, count);

      if (count === 0) {
        return array;
      }

      var buffer = TypedArrayPrototypeGetBuffer(float16bitsArray);

      if (IsDetachedBuffer(buffer)) {
        throw NativeTypeError(ATTEMPTING_TO_ACCESS_DETACHED_ARRAYBUFFER);
      }

      var n = 0;

      while (k < final) {
        array[n] = convertToNumber(float16bitsArray[k]);
        ++k;
        ++n;
      }

      return (
        /** @type {any} */
        array
      );
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray */

  }, {
    key: "subarray",
    value: function subarray() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var Constructor = SpeciesConstructor(float16bitsArray, Float16Array);
      var uint16 = new NativeUint16Array(TypedArrayPrototypeGetBuffer(float16bitsArray), TypedArrayPrototypeGetByteOffset(float16bitsArray), TypedArrayPrototypeGetLength(float16bitsArray));

      for (var _len4 = arguments.length, opts = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        opts[_key4] = arguments[_key4];
      }

      var uint16Subarray = TypedArrayPrototypeSubarray.apply(void 0, [uint16].concat(_toConsumableArray(toSafe(opts))));
      var array = new Constructor(TypedArrayPrototypeGetBuffer(uint16Subarray), TypedArrayPrototypeGetByteOffset(uint16Subarray), TypedArrayPrototypeGetLength(uint16Subarray));
      assertSpeciesTypedArray(array);
      return (
        /** @type {any} */
        array
      );
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof */

  }, {
    key: "indexOf",
    value: function indexOf(element) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var from = ToIntegerOrInfinity(arguments.length <= 1 ? undefined : arguments[1]);

      if (from === Infinity) {
        return -1;
      }

      if (from < 0) {
        from += length;

        if (from < 0) {
          from = 0;
        }
      }

      for (var i = from; i < length; ++i) {
        if (ObjectHasOwn(float16bitsArray, i) && convertToNumber(float16bitsArray[i]) === element) {
          return i;
        }
      }

      return -1;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof */

  }, {
    key: "lastIndexOf",
    value: function lastIndexOf(element) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var from = (arguments.length <= 1 ? 0 : arguments.length - 1) >= 1 ? ToIntegerOrInfinity(arguments.length <= 1 ? undefined : arguments[1]) : length - 1;

      if (from === -Infinity) {
        return -1;
      }

      if (from >= 0) {
        from = from < length - 1 ? from : length - 1;
      } else {
        from += length;
      }

      for (var i = from; i >= 0; --i) {
        if (ObjectHasOwn(float16bitsArray, i) && convertToNumber(float16bitsArray[i]) === element) {
          return i;
        }
      }

      return -1;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes */

  }, {
    key: "includes",
    value: function includes(element) {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var length = TypedArrayPrototypeGetLength(float16bitsArray);
      var from = ToIntegerOrInfinity(arguments.length <= 1 ? undefined : arguments[1]);

      if (from === Infinity) {
        return false;
      }

      if (from < 0) {
        from += length;

        if (from < 0) {
          from = 0;
        }
      }

      var isNaN = NumberIsNaN(element);

      for (var i = from; i < length; ++i) {
        var value = convertToNumber(float16bitsArray[i]);

        if (isNaN && NumberIsNaN(value)) {
          return true;
        }

        if (value === element) {
          return true;
        }
      }

      return false;
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.join */

  }, {
    key: "join",
    value: function join() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var array = copyToArray(float16bitsArray);

      for (var _len5 = arguments.length, opts = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        opts[_key5] = arguments[_key5];
      }

      return ArrayPrototypeJoin.apply(void 0, [array].concat(_toConsumableArray(toSafe(opts))));
    }
    /** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring */

  }, {
    key: "toLocaleString",
    value: function toLocaleString() {
      assertFloat16Array(this);
      var float16bitsArray = getFloat16BitsArray(this);
      var array = copyToArray(float16bitsArray); // @ts-ignore

      for (var _len6 = arguments.length, opts = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        opts[_key6] = arguments[_key6];
      }

      return ArrayPrototypeToLocaleString.apply(void 0, [array].concat(_toConsumableArray(toSafe(opts))));
    }
    /** @see https://tc39.es/ecma262/#sec-get-%typedarray%.prototype-@@tostringtag */

  }, {
    key: SymbolToStringTag,
    get: function get() {
      if (isFloat16Array(this)) {
        return (
          /** @type {any} */
          "Float16Array"
        );
      }
    }
  }], [{
    key: "from",
    value: function from(src) {
      var Constructor = this;

      if (!ReflectHas(Constructor, brand)) {
        throw NativeTypeError(THIS_CONSTRUCTOR_IS_NOT_A_SUBCLASS_OF_FLOAT16ARRAY);
      } // for optimization


      if (Constructor === Float16Array) {
        if (isFloat16Array(src) && (arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
          var float16bitsArray = getFloat16BitsArray(src);
          var uint16 = new NativeUint16Array(TypedArrayPrototypeGetBuffer(float16bitsArray), TypedArrayPrototypeGetByteOffset(float16bitsArray), TypedArrayPrototypeGetLength(float16bitsArray));
          return new Float16Array(TypedArrayPrototypeGetBuffer(TypedArrayPrototypeSlice(uint16)));
        }

        if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
          return new Float16Array(TypedArrayPrototypeGetBuffer(Uint16ArrayFrom(src, roundToFloat16Bits)));
        }

        var mapFunc = arguments.length <= 1 ? undefined : arguments[1];
        var thisArg = arguments.length <= 2 ? undefined : arguments[2];
        return new Float16Array(TypedArrayPrototypeGetBuffer(Uint16ArrayFrom(src, function (val) {
          for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
            args[_key7 - 1] = arguments[_key7];
          }

          return roundToFloat16Bits(ReflectApply(mapFunc, this, [val].concat(_toConsumableArray(toSafe(args)))));
        }, thisArg)));
      }
      /** @type {ArrayLike<unknown>} */


      var list;
      /** @type {number} */

      var length;
      var iterator = src[SymbolIterator];

      if (iterator != null && typeof iterator !== "function") {
        throw NativeTypeError(ITERATOR_PROPERTY_IS_NOT_CALLABLE);
      }

      if (iterator != null) {
        // Iterable (TypedArray, Array)
        // for optimization
        if (isOrdinaryArray(src)) {
          list = src;
          length = src.length;
        } else if (isOrdinaryTypedArray(src)) {
          list = src;
          length = TypedArrayPrototypeGetLength(src);
        } else {
          // eslint-disable-next-line no-restricted-syntax
          list = _toConsumableArray(src);
          length = list.length;
        }
      } else {
        // ArrayLike
        if (src == null) {
          throw NativeTypeError(CANNOT_CONVERT_UNDEFINED_OR_NULL_TO_OBJECT);
        }

        list = NativeObject(src);
        length = ToLength(list.length);
      }

      var array = new Constructor(length);

      if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        for (var i = 0; i < length; ++i) {
          array[i] =
          /** @type {number} */
          list[i];
        }
      } else {
        var _mapFunc = arguments.length <= 1 ? undefined : arguments[1];

        var _thisArg = arguments.length <= 2 ? undefined : arguments[2];

        for (var _i3 = 0; _i3 < length; ++_i3) {
          array[_i3] = ReflectApply(_mapFunc, _thisArg, [list[_i3], _i3]);
        }
      }

      return array;
    }
    /**
     * limitation: `Object.getOwnPropertyNames(Float16Array)` or `Reflect.ownKeys(Float16Array)` include this key
     *
     * @see https://tc39.es/ecma262/#sec-%typedarray%.of
     */

  }, {
    key: "of",
    value: function of() {
      var Constructor = this;

      if (!ReflectHas(Constructor, brand)) {
        throw NativeTypeError(THIS_CONSTRUCTOR_IS_NOT_A_SUBCLASS_OF_FLOAT16ARRAY);
      }

      var length = arguments.length; // for optimization

      if (Constructor === Float16Array) {
        var proxy = new Float16Array(length);
        var float16bitsArray = getFloat16BitsArray(proxy);

        for (var i = 0; i < length; ++i) {
          float16bitsArray[i] = roundToFloat16Bits(i < 0 || arguments.length <= i ? undefined : arguments[i]);
        }

        return proxy;
      }

      var array = new Constructor(length);

      for (var _i4 = 0; _i4 < length; ++_i4) {
        array[_i4] = _i4 < 0 || arguments.length <= _i4 ? undefined : arguments[_i4];
      }

      return array;
    }
  }]);

  return Float16Array;
}();
/** @see https://tc39.es/ecma262/#sec-typedarray.bytes_per_element */

ObjectDefineProperty(Float16Array, "BYTES_PER_ELEMENT", {
  value: BYTES_PER_ELEMENT
}); // limitation: It is peaked by `Object.getOwnPropertySymbols(Float16Array)` and `Reflect.ownKeys(Float16Array)`

ObjectDefineProperty(Float16Array, brand, {});
/** @see https://tc39.es/ecma262/#sec-properties-of-the-typedarray-constructors */

ReflectSetPrototypeOf(Float16Array, TypedArray);
var Float16ArrayPrototype = Float16Array.prototype;
/** @see https://tc39.es/ecma262/#sec-typedarray.prototype.bytes_per_element */

ObjectDefineProperty(Float16ArrayPrototype, "BYTES_PER_ELEMENT", {
  value: BYTES_PER_ELEMENT
});
/** @see https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator */

ObjectDefineProperty(Float16ArrayPrototype, SymbolIterator, {
  value: Float16ArrayPrototype.values,
  writable: true,
  configurable: true
}); // To make `new Float16Array() instanceof Uint16Array` returns `false`

ReflectSetPrototypeOf(Float16ArrayPrototype, TypedArrayPrototype);